import ConfirmParentProspecting from './ConfirmParentProspecting';

export default ConfirmParentProspecting;
